(function () {
  const container = document.querySelector('.districts-js');
  if (!container) return;

  const items = Array.from(container.querySelectorAll('a'));
  const isMobile = window.innerWidth <= 768;

  items.forEach(el => {
    const weight = Number(el.dataset.weight) || 2;

    // tipográfia súly szerint
    if (weight >= 5) {
  el.style.fontSize = isMobile ? '2.4rem' : '3.6rem';
  el.style.fontWeight = '600';
} else if (weight >= 3) {
  el.style.fontSize = isMobile ? '2rem' : '3rem';
  el.style.fontWeight = '500';
} else {
  el.style.fontSize = isMobile ? '1.6rem' : '2.4rem';
  el.style.fontWeight = '400';
}
  });
})();
